/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { putData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

const ProjectHeader = ({
  setDownloadExcel,
  setSearch,
  records,
  blockRefSelected,
}) => {
  const { setreloadProjectList, setSuccess, setError, setNotificationString } =
    useContext(GlobalProvider);

  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  /* hook to get the search value */
  const [searchValue, setSearchValue] = useState("");

  /* function to click download xls*/
  const handleDownloadClick = () => {
    setDownloadExcel(true);
    setTimeout(() => setDownloadExcel(false), 500);
  };

  //function for delete label
  const deleteProjectHandler = () => {
    const checkboxes = document.querySelectorAll(
      'input[name="selectProjectRecord"]'
    );

    checkboxes.forEach(async (checkbox) => {
      if (checkbox.checked) {
        try {
          let projectData = {
            status: "0",
          };

          let requestUrl =
            url.API_BASEURL +
            url.API_UPDATE_PROJECT +
            `/${checkbox.value}` +
            `?token=${token}`;

          const response = await putData(requestUrl, projectData);

          if (response.status) {
            setreloadProjectList(true);
            setSuccess(true);
            setNotificationString(t("Label has been deleted successfully"));
          }
        } catch (error) {
          console.error(error.message);
          setError(true);
          setNotificationString(
            t("Something went wrong, please try again later")
          );
        }
      }
    });
  };

  /* hook to empty search when searchValue gets empty */
  useEffect(() => {
    !searchValue && setSearch("");
  }, [searchValue]);

  return (
    <div className="filter-container d-flex flex-wrap align-items-center gap-2 border-bottom border-gray">
      {/* -------- toggle column button start -------- */}
      {/* <Link
        to="#"
        className="column-collapse btn btn-primary icon-btn mw-unset"
      >
        <span className="d-block material-symbols-outlined icon-fill">
          visibility
        </span>
      </Link> */}
      {/* -------- toggle column button end -------- */}

      {/* -------- download button start -------- */}
      <Link
        to="#"
        onClick={handleDownloadClick}
        className="download btn btn-primary icon-btn mw-unset"
      >
        <span className="d-block material-symbols-outlined">download</span>
      </Link>
      {/* -------- download button end -------- */}

      {/* -------- search section start -------- */}
      <div className="search-container position-relative d-none d-md-block">
        <form onSubmit={(e) => e.preventDefault()}>
          <input
            type="search"
            placeholder={t("Search here")}
            className="form-control bg-transparent py-2 border-0"
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => {
              e.key === "Enter" && (e.preventDefault(), setSearch(searchValue));
            }}
          />
          <button
            onClick={() => setSearch(searchValue)}
            type="submit"
            className="bg-transparent text-dark p-0 border-0 position-absolute top-50 translate-middle-y"
          >
            <span className="d-block material-symbols-outlined">search</span>
          </button>
        </form>
      </div>
      {/* -------- search section end -------- */}
      {/* ------------- showing records start ----------------- */}
      <p className="text-gray fw-medium ms-auto me-3">
        {t("Showing")}
        <span className="text-black ms-1">{records}</span> {t("Records")} -
        <span className="text-black ms-1" ref={blockRefSelected}>
          {" "}
          0{" "}
        </span>{" "}
        {t("Selected")}
      </p>
      {/* ------------- showing records end ----------------- */}
      {/* ----- refresh icon start ------ */}
      <Link
        to="#"
        className="filter-btn btn btn-primary icon-btn mw-unset "
        onClick={() => {
          setreloadProjectList(true);
          setSuccess(true);
          setNotificationString(t("The list has been refreshed successfully"));
        }}
      >
        <span className="d-block material-symbols-outlined">refresh</span>
      </Link>
      {/* ----- refresh icon end ------ */}

      {/* ---------- search filter button start -------- */}
      <Link
        to="#filterCollapse"
        className="filter-btn btn btn-primary icon-btn mw-unset"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="false"
        aria-controls="filterCollapse"
      >
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={t("Filter")}
          className="d-block material-symbols-outlined"
        >
          filter_alt
        </span>
      </Link>
      {/* ---------- search filter button end -------- */}

      {/* -------- add new project popip button start -------- */}
      <Link
        to="#addUpdateProjectPopup"
        data-bs-toggle="offcanvas"
        role="button"
        aria-controls="addLabelPopup"
        className="save-reservation btn btn-primary icon-btn mw-unset"
      >
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={t("Add new project")}
          className="d-block material-symbols-outlined"
        >
          add
        </span>
      </Link>
      {/* -------- add new project popip button end -------- */}

      {/* -------- dropdown button start -------- */}
      <div className="dropdown">
        <button
          className="btn btn-primary dropdown-toggle mw-unset"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {t("Actions")}
        </button>
        <ul className="dropdown-menu border-0 shadow-lg">
          {/* ------ add tag button start ------- */}
          <li>
            <Link
              to="#tags_pnl"
              data-bs-toggle="offcanvas"
              role="button"
              className="dropdown-item"
            >
              {t("Add/Remove Label")}
            </Link>
          </li>
          {/* ------ add tag button end ------- */}
          <li>
            <Link
              className="dropdown-item"
              to="#"
              onClick={deleteProjectHandler}
            >
              {t("Delete selected")}
            </Link>
          </li>
        </ul>
      </div>
      {/* -------- dropdown button end -------- */}
    </div>
  );
};

export default ProjectHeader;
